import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/ko';
import { homeActions } from '../../../store/home';

import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../assets/front/css/custom/profile.css";
//import "../../../assets/front/css/custom/slick.css";

// https://swiper6.vercel.app/react, https://swiper6.vercel.app/swiper-api
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';

import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import kara from '../../../assets/front/img/header/kara.jpg';
import preloader from '../../../assets/front/img/catWalk.gif';

import aside1 from '../../../assets/front/img/footer/aside-1.png';
import aside2 from '../../../assets/front/img/footer/aside-2.png';
import aside3 from '../../../assets/front/img/footer/aside-3.png';

import instagram1 from '../../../assets/front/img/instagram/1.jpg';
import instagram2 from '../../../assets/front/img/instagram/2.jpg';
import instagram3 from '../../../assets/front/img/instagram/3.jpg';
import instagram4 from '../../../assets/front/img/instagram/4.jpg';
import instagram5 from '../../../assets/front/img/instagram/5.jpg';
import instagram6 from '../../../assets/front/img/instagram/6.jpg';
import instagram7 from '../../../assets/front/img/instagram/7.jpg';
import instagram8 from '../../../assets/front/img/instagram/8.jpg';
import instagram9 from '../../../assets/front/img/instagram/9.jpg';
import instagram10 from '../../../assets/front/img/instagram/10.jpg';
import instagram11 from '../../../assets/front/img/instagram/11.jpg';
import instagram12 from '../../../assets/front/img/instagram/12.jpg';

const IngstagramImages = [
    { id: 1, src: instagram1, address: 'https://www.instagram.com/p/CcNHkDcLpqD/' },
    { id: 2, src: instagram2, address: 'https://www.instagram.com/p/CjuM0fbL-c6/' },
    { id: 3, src: instagram3, address: 'https://www.instagram.com/p/CjrqtUyLhdK/' },
    { id: 4, src: instagram4, address: 'https://www.instagram.com/p/CjcxTE6rN5q/' },
    { id: 5, src: instagram5, address: 'https://www.instagram.com/p/CjcNbB9Ln3u/' },
    { id: 6, src: instagram6, address: 'https://www.instagram.com/p/CjaDSRfL_Pp/' },
    { id: 7, src: instagram7, address: 'https://www.instagram.com/p/CjZyrHOrakq/' },
    { id: 8, src: instagram8, address: 'https://www.instagram.com/p/CjXy4MApyZ1/' },
    { id: 9, src: instagram9, address: 'https://www.instagram.com/p/CjKrR2rJVMn/' },
    { id: 10, src: instagram10, address: 'https://www.instagram.com/p/CjKKZeRLTx9/' },
    { id: 11, src: instagram11, address: 'https://www.instagram.com/p/CjIP9MLJnG6/' },
    { id: 12, src: instagram12, address: 'https://www.instagram.com/p/CjEvD9xJ9nb/' },
];


function SampleNextArrow(props) {
    const { onClick } = props;
    return (
        <div className="js-next u-arrow-v1 g-absolute-centered--y g-width-65 g-height-65 g-font-size-40 g-font-weight-300 g-color-gray-light-v1 g-color-white--hover icon-arrow-right g-right-30"
            onClick={onClick}
        />
    );
}
function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
        <div className="js-prev u-arrow-v1 g-absolute-centered--y g-width-65 g-height-65 g-font-size-40 g-font-weight-300 g-color-gray-light-v1 g-color-white--hover icon-arrow-left g-left-30"
            onClick={onClick}
        />
    );
}

class Home extends React.Component {

    constructor(props) {
        super(props);

        moment.locale('ko');

        this.state = {
            activePill: '1'
        };

        this.navigationPrevRef = React.createRef(null);
        this.navigationNextRef = React.createRef(null);
        this.paginationRef = React.createRef(null);
    }

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
        this.props.getHome();
    }

    togglePill(pill) {
        if (this.state.activePill !== pill) {
            this.setState({
                activePill: pill
            });
        }
    }

    getContent(item, index) {
        let file = null;
        item.files.map((item) => {
            if (item.type === "thumbnails") file = item;
            return null;
        })

        return (
            <div key={index} className={`col-6 col-md-4 col-sm-6 ${index === 8 ? "g-hidden-sm-down" : ""}`}>
                {file && <Link to={`/details/${item.category}/${item.subCategory}/${item.boardId}`}><img src={`/api/files/thumbnails/${file.name}`} className="img-fluid" alt="" /></Link>}
                {!file && <Link to={`/details/${item.category}/${item.subCategory}/${item.boardId}`}><img src={kara} className="img-fluid" alt="" /></Link>}
                <p className="g-text-nowrap g-mt-10 g-mb-5"><Link to={`/details/${item.category}/${item.subCategory}/${item.boardId}`} className="g-color-main">{item.title}</Link></p>
                <p className="g-font-size-12 g-mb-30">{moment(item.time).format("YYYY-MM-DD")}</p>
            </div>
        )
    }

    render() {
        //if (!this.props.home.banners) return null;
        //console.log(this.props);

        const settings = {
            infinite: true,
            autoplay: true,
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }; 

        SwiperCore.use([Autoplay]);
        SwiperCore.use([Navigation])
        SwiperCore.use([Pagination])

        const self = this;

        return (
            <div className="g-pt-130 g-pt-160--sm-up g-pt-160--xs-up">

                {/* Swiper */}
                <div className="g-mb-20 g-mb-30--md">

                    <Swiper style={{ height: "400px" }}
                        autoplay={{
                            delay: 8000,
                            disableOnInteraction: false,
                        }}
                    >
                        {this.props.home.banners && this.props.home.banners.map((item, index) => {
                            if (item.category === 'home' && item.subCategory === 'main') {
                                return (
                                    <SwiperSlide key={index} style={{ backgroundColor: item.option }}></SwiperSlide>
                                );
                            } else return null;
                        })}
                    </Swiper>

                    <div className="container">
                        <div style={{ marginTop: '-350px' }}>

                            <Swiper
                                modules={[Navigation, Pagination]}
                                autoplay={{
                                    delay: 8000,
                                    disableOnInteraction: false,
                                }}
                                navigation={{
                                    prevEl: self.navigationPrevRef.current,
                                    nextEl: self.navigationNextRef.current,
                                }}
                                pagination={{
                                    el: '.swiper-pagination',
                                    type: "fraction",
                                    clickable: true,
                                    renderBullet: (index, className) => {
                                        return index + 1;
                                    },
                                }}
                                onBeforeInit={(swiper) => {
                                    swiper.params.navigation.prevEl = self.navigationPrevRef.current;
                                    swiper.params.navigation.nextEl = self.navigationNextRef.current;
                                    swiper.params.pagination.el = self.paginationRef.current;
                                }}

                                //onSwiper={(swiper) => console.log(swiper)}
                                //onSlideChange={() => { console.log('slide change'); }}
                            >
                                {this.props.home.banners && this.props.home.banners.map((item, index) => {
                                    if (item.category === 'home' && item.subCategory === 'main') {
                                        //console.log(index + " : " + item.link)
                                        //console.log(this.props.home.banners.length);
                                        return (
                                            <div key={index}>

                                                <SwiperSlide key={index}>     

                                                    {/* PC */}
                                                    <div className="g-hidden-md-down">
                                                        <div className="row" style={{ marginLeft: "-15px", marginRight: "-15px" }}>
                                                            <div className="col-7 g-px-15">
                                                                <a href={item.link} target={item.target}>
                                                                    <img src={`/api/files/banners/${item.image}`} className="img-fluid mx-auto d-block" alt={item.title} />
                                                                </a>
                                                            </div>
                                                            <div className="col-5 g-px-15">
                                                                <div className="g-py-30 g-mb-30 g-px-20--lg">
                                                                    <a href={item.link} className="g-color-white g-line-height-1_3">
                                                                        <span className="g-font-size-30 font-weight-bold" style={{ wordBreak: "keep-all" }}>{item.title}</span>
                                                                        <br /><br />
                                                                        <span className="g-font-size-14 g-pl-3" style={{ wordBreak: "keep-all"}}>{item.summary}</span>
												                    </a>
                                                                </div>
                                                                {/*
                                                                <div className="d-none">
                                                                    <div className="g-mt-10">
                                                                        <div ref={self.navigationPrevRef} className="swiper-button-prev g-color-white home-swiper-prev position-absolute g-font-size-26" style={{ left: "35px", top: "auto", bottom: "60px" }}><i className="icon-arrow-left"></i></div>
                                                                        <div className="swiper-pagination g-color-white text-left position-absolute g-pt-10" style={{ left: "75px", bottom: "72px", width: "100px" }}></div>
                                                                        <div ref={self.navigationNextRef} className="swiper-button-next g-color-white home-swiper-next position-absolute g-font-size-26" style={{ left: "115px", top: "auto", bottom: "60px" }}><i className="icon-arrow-right"></i></div>
                                                                    </div>
                                                                  </div>
                                                                  */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Mobile */}
                                                    <div className="g-hidden-lg-up">
                                                        <div className="row" style={{ marginLeft: "-15px", marginRight: "-15px" }}>
                                                            <div className="col-12 g-px-15 g-mb-30">
                                                                <a href={item.link} className="g-color-white g-line-height-1_3">
                                                                    <span className="g-font-size-24 font-weight-bold" style={{ wordBreak: "keep-all" }}>{item.title}</span>
                                                                    <br /><br />
                                                                    <span className="g-font-size-14" style={{ wordBreak: "keep-all" }}>{item.summary}</span>
											                    </a>
                                                            </div>
                                                            <div className="col-12 g-px-15">
                                                                <a href={item.link}><img className="img-fluid w-100" src={`/api/files/banners/${item.image}`} alt={item.title} /></a>
										                    </div>
                                                        </div>
                                                    </div>

                                                </SwiperSlide>

                                            </div>
                                        );
                                    } else return null;
                                })}

                            </Swiper>

                            <div className="g-hidden-lg-down">
                                <div className="g-mt-10">
                                    <div ref={self.navigationPrevRef} className="swiper-button-prev g-color-white home-swiper-prev position-absolute g-font-size-26" style={{ left: "58%", top: "490px", bottom: "auto" }}><i className="icon-arrow-left"></i></div>
                                    <div ref={self.pagnationRef} className="swiper-pagination g-color-white text-left position-absolute g-pt-10" style={{ left: "60.5%", top: "470px", bottom: "auto", width: "100px" }}></div>
                                    <div ref={self.navigationNextRef} className="swiper-button-next g-color-white home-swiper-next position-absolute g-font-size-26" style={{ left: "63%", top: "490px", bottom: "auto" }}><i className="icon-arrow-right"></i></div>
                                </div>
                            </div>

                            {!this.props.home.banners &&
                                <div className="text-center g-min-height-100 g-mt-170 g-mb-170">
                                    <img src={preloader} alt="" />
                                </div>
                            }
                        </div>

                    </div>
                </div>
                
                {/* 사이드 배너 */}
                <div className="container g-hidden-xl-up">
                    <div className="row text-center g-mb-20">
                        <div className="col">
                            <a href="https://page.stibee.com/subscriptions/166721" target="_blink">
                                <img src={aside1} className="img-fluid" alt="" />
                            </a>
                        </div>
                        <div className="col">
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeM-JrEjZ8wJNswKTofvnbeFhlXqwgCi3HgbwtSqp8J0xQBog/viewform" target="_blink">
                                <img src={aside2} className="img-fluid" alt="" />
                            </a>
                        </div>
                        <div className="col">
                            <a href="https://ekara.org/support/introduce" target="_blink">
                                <img src={aside3} className="img-fluid" alt="" /></a>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        {/* 게시판 */}
                        <div className="col-lg-8 g-pt-15 g-pb-0 g-pb-10--lg">
                            <Nav pills className="g-pl-5 g-pb-10 ">
                                <NavItem>
                                    <NavLink className={classnames("g-cursor-pointer rounded-0 g-font-size-15 g-font-weight-600 g-px-5 g-px-30--lg g-px-15--sm g-py-4", { active: this.state.activePill === '1' })} onClick={() => { this.togglePill('1'); }} >
                                        <span className="d-sm-none">전체</span>
                                        <span className="d-sm-block d-none">전체</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames("g-cursor-pointer rounded-0 g-font-size-15 g-font-weight-600 g-px-5 g-px-30--lg g-px-15--sm g-py-4", { active: this.state.activePill === '2' })} onClick={() => { this.togglePill('2'); }} >
                                        <span className="d-sm-none">교육소식</span>
                                        <span className="d-sm-block d-none">교육소식</span>
                                    </NavLink>
                                </NavItem>
                                {/*
                                <NavItem>
                                    <NavLink className={classnames("g-cursor-pointer rounded-0 g-font-size-15 g-font-weight-600 g-px-5 g-px-30--lg g-px-15--sm g-py-4", { active: this.state.activePill === '3' })} onClick={() => { this.togglePill('3'); }} >
                                        <span className="d-sm-none">더배움</span>
                                        <span className="d-sm-block d-none">더배움</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink className={classnames("g-cursor-pointer rounded-0 g-font-size-15 g-font-weight-600 g-px-5 g-px-30--lg g-px-15--sm g-py-4", { active: this.state.activePill === '4' })} onClick={() => { this.togglePill('4'); }} >
                                        <span className="d-sm-none">영화제</span>
                                        <span className="d-sm-block d-none">영화제 소식</span>
                                    </NavLink>
                                </NavItem> */}
                                <NavItem>
                                    <NavLink className={classnames("g-cursor-pointer rounded-0 g-font-size-15 g-font-weight-600 g-px-5 g-px-30--lg g-px-15--sm g-py-4", { active: this.state.activePill === '5' })} onClick={() => { this.togglePill('5'); }} >
                                        <span className="d-sm-none">도서관</span>
                                        <span className="d-sm-block d-none">도서관 소식</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            {this.props.home.boards &&
                                <TabContent activeTab={this.state.activePill} className="g-px-10 g-pt-10 g-pb-0 g-mb-0 g-pb-10--lg">
                                        <TabPane tabId="1">
                                            <div className="row">
                                                {this.props.home.boards.map((item, index) => {
                                                    return this.getContent(item, index);
                                                })}
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="2">
                                            <div className="row">
                                                {this.props.home.visits.map((item, index) => {
                                                    return this.getContent(item, index);
                                                })}
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="3">
                                            <div className="row">
                                                {this.props.home.learns.map((item, index) => {
                                                    return this.getContent(item, index);
                                                })}
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="4">
                                            <div className="row">
                                                {this.props.home.articles.map((item, index) => {
                                                    return this.getContent(item, index);
                                                })}
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="5">
                                            <div className="row">
                                                {this.props.home.news.map((item, index) => {
                                                    return this.getContent(item, index);
                                                })}
                                            </div>
                                        </TabPane>
                                </TabContent>
                            }
                        </div>

                        <div className="col-lg-4 g-pt-15">
                            {/* 자료실 */}
                            <div className="g-px-15--lg">
                                <p className="g-font-weight-600 g-font-size-18 g-mb-15"><Link to="/home/resource" className="g-color-primary">자료실</Link></p>
                                {this.props.home.resources && this.props.home.resources.map((item, index) => {
                                    return (
                                        <article key={item.boardId} className="g-mb-10">
                                            <span className="d-block g-color-gray-dark-v4 g-font-weight-500 g-font-size-12 text-uppercase mb-2">{moment(item.time).format("YYYY-MM-DD")}</span>
                                            <h2 className="h6 g-color-black mb-3"><Link to={{ pathname: `/details/home/resource/${item.boardId}` }} className="u-link-v5 g-color-black g-color-primary--hover">{item.title}</Link></h2>
                                            <hr className="g-my-10" />
                                        </article>
                                    );
                                })}
                            </div>

                            {/* 교육 일정 */}
                            <div className="profile">
                                <p className="g-font-weight-600 g-font-size-18 g-pt-5 g-pl-10--lg mb-0"><Link to="/activity/calendar" className="g-color-primary">교육일정</Link></p>
                                {this.props.home.events && this.props.home.events.map((item, index) => {
                                    return (
                                        <div key={index} >
                                            <div className="profile-event">
                                                <div className="date-formats">
                                                    <span>{moment(item.start.dateTime).format("DD")}</span>
                                                    <small>{moment(item.start.dateTime).format("MM")}, {moment(item.start.dateTime).format("YYYY")}</small>
                                                </div>
                                                <p className="g-pt-5"><Link to="/activity/calendar" className="g-color-black g-text-nowrap">{item.summary}</Link></p>
                                                <p className="mb-0">{moment(item.start.dateTime).format("LLL")}</p>
                                            </div>
                                            {index !== 3 && <hr className="g-mx-10 g-mt-16 g-mb-0" />}
                                        </div>
                                    );
                                })}
                            </div>

                            {/* 사이드 배너 
                            <div className="side-banner g-px-15--lg g-py-50 g-pt-30--md g-pb-0--lg">
                                {this.props.home.banners &&
                                    <Slider {...settings}>
                                        {this.props.home.banners.map((item, index) => {
                                            if (item.category === 'home' && item.subCategory === 'side') {
                                                return (
                                                    <div key={item.bannerId}>
                                                        <a href={item.link} target={item.target}><img src={`/api/files/banners/${item.image}`} className="img-fluid mx-auto d-block" alt={item.title} /></a>
                                                    </div>
                                                );
                                            } else return null;
                                        })}
                                    </Slider>
                                }
                            </div>
                            */}

                        </div>
                    </div>
                </div>

                {/* 인스타그램 
                <div className="g-bg-black">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-2">
                                <div className="text-center g-color-white g-pt-20 g-pt-55--lg">
                                    <h4 className="g-font-weight-600">Follow</h4>
                                    <h4 className="g-font-weight-600"><a href="https://www.instagram.com/kara_library/" target="_blank" rel="noopener noreferrer" style={{ color: "#42c49e"}}>@kara_library</a></h4>
                                    <h4 className="g-font-weight-600">on Instagram</h4>
                                </div>
                            </div>
                            <div className="col-lg-10">
                                <Slider {...settings}>
                                    {IngstagramImages.map((item, index) => (
                                        <div key={index} className="g-px-5 g-pt-20 g-pb-15">
                                            <a href={item.address} target="_blank"><img src={item.src} alt={index} className="img-fluid" /></a>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* 후원계좌 */}
                <div className="g-bg-primary g-font-size-12 g-color-white">
                    <div className="container">
                        {/* PC */}    
                        <div className="g-hidden-sm-down">
			                <div className="row no-gutters text-center g-py-5 g-py-0--lg">
                                <div className="col-6 col-md-4 col-lg-2 g-py-5 g-py-18--lg">
                                    <p className="mb-0">예금주:(사)동물권행동 카라</p>
                                </div>
                                <div className="col-6 col-md-4 col-lg-2 g-py-5 g-py-18--lg">
                                    <p className="mb-0">1005-001-646488 우리은행</p>
                                </div>
                                <div className="col-6 col-md-4 col-lg-2 g-py-5 g-py-18--lg">
                                    <p className="mb-0">043937-04-003118 국민은행</p>
                                </div>
                                <div className="col-6 col-md-4 col-lg-2 g-py-5 g-py-18--lg">
                                    <p className="mb-0">025-075183-04-011 기업은행</p>
                                </div>
                                <div className="col-6 col-md-4 col-lg-2 g-py-5 g-py-18--lg">
                                    <p className="mb-0">301-0052-1096-81 농협중앙회</p>
                                </div>
                                <div className="col-6 col-md-4 col-lg-2 g-py-5 g-pb-10 g-py-18--lg">
                                    <p className="mb-0">후원 문의: info@ekara.org</p>
                                </div>
                            </div>
                        </div>
                        {/* Mobile */} 
                        <div className="g-hidden-md-up">
                            <div className="row g-py-30">
                                <div className="col-5 g-pl-20">
                                    <p className="font-weight-bold mb-0">예금주</p>
                                    <p>(사)동물권행동 카라</p>
                                    <p className="font-weight-bold  mb-0">후원 문의</p>
                                    <p className="mb-0">info@ekara.org</p>
                                </div>
                                <div className="col-7">
                                    <p className="mb-2">우리은행 1005-001-646488</p>
                                    <p className="mb-2">국민은행 043937-04-003118</p>
                                    <p className="mb-2">기업은행 025-075183-04-001</p>
                                    <p className="mb-0">농협은행 301-0052-1096-81</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.home,
    dispatch => bindActionCreators({ ...homeActions }, dispatch)
)(withRouter(Home));



// WEBPACK FOOTER //
// ./src/pages/front/home/index.js